import { render, staticRenderFns } from "./staffCommunityFeeSummaryList.vue?vue&type=template&id=db4c7bea&scoped=true"
import script from "./staffCommunityFeeSummaryList.vue?vue&type=script&lang=js"
export * from "./staffCommunityFeeSummaryList.vue?vue&type=script&lang=js"
import style0 from "./staffCommunityFeeSummaryList.vue?vue&type=style&index=0&id=db4c7bea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db4c7bea",
  null
  
)

export default component.exports